"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("styled-components"),a=require("react"),t=require("prop-types"),r=require("focus-trap-react"),o=require("@vds-core/utilities"),l=require("@vds-tokens/color"),i=require("./LoaderPortal.js"),n=require("./LoaderAnimations.js");function d(e){return e&&e.__esModule?e:{default:e}}var u=d(e),c=d(a),s=d(t),f=d(r);const p={active:s.default.bool,fullscreen:s.default.bool,id:s.default.string,disableFocusLock:s.default.bool,surface:s.default.oneOf(["light","dark"])},m={active:!1,fullscreen:!1,disableFocusLock:!1,surface:"light"},v=u.default.div.withConfig({displayName:"StyledOverlay",componentId:"VDS__sc-27g4au-0"})`
  background-color: ${({surface:e})=>"dark"===e?l.ColorTokens.background.primary.dark.value:l.ColorTokens.background.primary.light.value};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  position: ${e=>e.fullscreen?"fixed":"absolute"};
  display: ${e=>e.active?"block":"none"};
  animation: ${e=>e.active?n.FadeInAnimation:n.FadeOutAnimation}
    0.15s linear;
  opacity: 0.8;
`,b=u.default.div.withConfig({displayName:"StyledLoader",componentId:"VDS__sc-27g4au-1"})`
  outline: none;
  display: ${e=>e.active?"block":"none"};
  animation: ${e=>e.active?n.FadeInAnimation:n.FadeOutAnimation}
    0.15s linear;
  content: '';
  position: ${e=>e.fullscreen?"fixed":"absolute"};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: ${o.calculateRem(40)};
  height: ${o.calculateRem(40)};
  display: block;
  z-index: 3;
  border: ${o.calculateRem(4)} solid
    ${({surface:e})=>"dark"===e?l.ColorTokens.elements.primary.ondark.value:l.ColorTokens.elements.primary.onlight.value};
  border-top-color: transparent;
  border-radius: 50%;
  animation: ${n.LoadingAnimation} 0.5s infinite linear;
`,y=({active:e,fullscreen:a,id:t,disableFocusLock:r,surface:o})=>e?a?c.default.createElement(i.default,{"aria-label":"loader container",id:t},c.default.createElement(f.default,{focusTrapOptions:{escapeDeactivates:!1},active:!r},c.default.createElement(v,{active:e,"aria-label":"loader overlay",fullscreen:a,surface:o},c.default.createElement(b,{tabIndex:0,active:e,"aria-label":"loader animation",surface:o})))):c.default.createElement(v,{active:e,"aria-label":"loader overlay",surface:o},c.default.createElement(b,{tabIndex:0,active:e,"aria-label":"loader animation",surface:o})):null;y.propTypes=p,y.defaultProps=m;var g=o.withVDSManager(y);exports.default=g,exports.defaultProps=m,exports.propTypes=p;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/loaders/cjs/components/Loader.js
// module id = 1022
// module chunks = 0